import { render } from "./jtTopicInfo.vue?vue&type=template&id=242401bc&scoped=true"
import script from "./jtTopicInfo.vue?vue&type=script&lang=js"
export * from "./jtTopicInfo.vue?vue&type=script&lang=js"

import "./jtTopicInfo.vue?vue&type=style&index=0&id=242401bc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242401bc"]])

export default __exports__